module.exports = __webpack_public_path__ + "static/media/3.12.db1aacf1.png";